(function() {
  'use strict';

  /**
   * @ngdoc service
   * @name webAgro1App.contratoservice
   * @description
   * # contratoservice
   * Factory in the webAgro1App.
   */
  angular
    .module('webAgro1App')
    .factory('ContratoService', ContratoServiceFactory);

  /**
   * ContratoServiceFactory dependencies
   */
  ContratoServiceFactory.$inject = [
    '$http'
  ];

  /**
   * ContratoServiceFactory declaration
   */
  function ContratoServiceFactory($http) {
    //////////////////////////////////////////
    // Data variables

    //////////////////////////////////////////
    // Service declaration
    const service = {
      get: Get,
      update: Update,
      messages: Messages,
      contractStatus: ContractStatus,
      renovation: Renovation
    };
    return service;

    //////////////////////////////////////////
    // Functions declarations

    function Get() {
      return $http.get(`${SERVER }v1/gpa`);
    }

    function Update() {
      return $http.post(`${SERVER }v1/gpa`);
    }

    function Messages() {
      return $http.get(`${SERVER }v1/gpa/mensagens`);
    }

    function ContractStatus() {
      return $http.get(`${SERVER }v1/gpa/contract_status`);
    }

    function Renovation(params) {
      return $http.post(`${SERVER }v1/gpa/renovation`, params);
    }
  }
}());
